import { useEffect, useState } from 'react'
import cn from 'classnames'
import { useTimer } from 'src/lib/useTimer'
import { ContentSteps } from 'src/lib/useStepFlow'
import Cells from 'src/icons/cells.webp'
import Ron from 'src/icons/ron.webp'
import Euro from 'src/icons/euro.webp'
import Egg from 'src/icons/egg.webp'
import CellEmpty from 'src/icons/cell-empty.webp'
import EggAnime from 'src/icons/egg-anime.gif'
import { TLang } from 'src/constants/langs'
import styles from './styles.module.scss'

type TProps = {
    onNext: (step: ContentSteps) => void
    step: ContentSteps
    lang: TLang
}

const generateInitialState = () =>
    Object.fromEntries(Array.from({ length: 9 }, (_, i) => [i, false]))

export const ThirdStep = ({ onNext, step, lang }: TProps) => {
    const { stopTimer, isRunning } = useTimer()

    const [stopPulse, setStopPulse] = useState<{ [key: number]: boolean }>(
        generateInitialState()
    )
    const [showCurrency, setShowCurrency] = useState<{
        [key: number]: boolean
    }>(generateInitialState())
    const [showAnime, setShowAnime] = useState<{
        [key: number]: boolean
    }>(generateInitialState())

    const [isLocked, setIsLocked] = useState(false)

    const imageByLang = lang === 'ro' ? lang : 'en'

    const handleEggClick = (index: number) => {
        if (isLocked || stopPulse[index]) return

        setStopPulse((prev) => ({
            ...prev,
            [index]: true,
        }))

        setShowAnime((prev) => ({
            ...prev,
            [index]: true,
        }))

        setTimeout(() => {
            setShowCurrency((prev) => ({
                ...prev,
                [index]: true,
            }))
            setTimeout(() => {
                setShowAnime((prev) => ({
                    ...prev,
                    [index]: false,
                }))
            }, 400)
        }, 500)
    }

    useEffect(() => {
        if (!isRunning) {
            setIsLocked(true)
            const timeout = setTimeout(() => {
                onNext(step)
            }, 1000)
            return () => clearTimeout(timeout)
        }

        const trueCount = Object.values(stopPulse).filter((v) => v).length

        if (trueCount === 3) {
            stopTimer()
        }
    }, [stopPulse, onNext, step, stopTimer, isRunning])

    return (
        <div className={styles.root}>
            <img src={Cells} alt="Cells" className={styles.cells} />
            {Array.from({ length: 9 }).map((_, index) => (
                <div
                    key={index}
                    className={cn(
                        styles.egg_wrapper,
                        styles[`egg_wrapper__${index}`]
                    )}
                >
                    <img
                        src={imageByLang === 'ro' ? Ron : Euro}
                        alt={`Currency__${imageByLang}`}
                        className={cn(
                            styles.currency,
                            styles[`currency__${imageByLang}`],
                            showCurrency[index] ? styles.visible : styles.hidden
                        )}
                    />
                    <img
                        src={EggAnime}
                        alt="EggAnime"
                        className={cn(
                            styles.eggAnime,
                            showAnime[index] ? styles.visible : styles.hidden
                        )}
                    />
                    <img
                        src={Egg}
                        alt="Egg"
                        className={cn(
                            styles.egg,
                            stopPulse[index] ? styles.hidden : styles.visible
                        )}
                    />
                    <div
                        onClick={() => handleEggClick(index)}
                        className={styles.clickable_area}
                    />
                </div>
            ))}
            <img
                src={CellEmpty}
                alt="CellEmpty"
                className={cn(styles.cell_empty)}
            />
        </div>
    )
}
